import { useAuth } from "../../../../../Context/AuthContext";
import { useQuery } from "@tanstack/react-query";
import { fetchPartners } from "../api/webservice";

export const useFetchPartners = () => {
  const auth = useAuth();
  const user = auth.getSessionData();

  return useQuery({
    queryKey: ["fetchPartnersByCustomers"],
    queryFn: async () =>
      await fetchPartners({
        token: user.token,
      }),
    refetchOnWindowFocus: false,
    initialData: [],
  });
};
